import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, NavLink, Navigate, useLocation } from 'react-router-dom';
import './SettingPageMain.css';

import Profile from './Profile';

const LOCAL_STORAGE_USER_KEY = 'zTaskUserDetails';

const SettingPageMain = ({ onProfileUpdate }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  // Basic role check if needed for Profile or future expansion, 
  // simplified since we only have Profile now.
  const checkUserRole = useCallback(() => {
    try {
      const userDataString = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        // Assuming we might want to know if user is admin later, keeping basic logic
        const userRole = userData?.role?.name?.toUpperCase();
        setIsAdmin(userRole === 'SUPER_ADMIN' || userRole === 'REPORTING MANAGER');
      }
    } catch (error) {
      console.error("SettingPageMain: Error checking role:", error);
    }
  }, []);

  useEffect(() => {
    checkUserRole();
    const handleStorageChange = (event) => {
      if (event.key === LOCAL_STORAGE_USER_KEY || event.key === null) {
        checkUserRole();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [checkUserRole, location.pathname]);

  const navItems = [
    { path: "/settings/profile", label: "Profile", icon: "👤" },
  ];

  return (
    <div className="settings-page-container">
      <h1 className="settings-title">Settings</h1>
      <nav className="settings-top-navbar">
        {navItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `top-nav-item ${isActive ? 'active' : ''}`}
          >
            <span role="img" aria-label={item.label.toLowerCase()}>{item.icon}</span> {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="settings-content-area">
        <Routes>
          <Route path="/" element={<Navigate to="/settings/profile" replace />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/settings/profile" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default SettingPageMain;